<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="rules" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">区域奖励设置</div>
      <el-form-item label="是否开启区域代理返利：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否开启差额：">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="省级区域奖" :rules="[{required: true,message: ' '}]" prop="province_rate">
        <el-input v-model="form.province_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为省级区域代理后，该地区的实付金额 的 {{form.province_rate}}% 收益奖励</div>
      </el-form-item>
      <el-form-item label="市级区域奖" :rules="[{required: true,message: ' '}]" prop="city_rate">
        <el-input v-model="form.city_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为市级区域代理后，该地区的实付金额 的 {{form.city_rate}}% 收益奖励</div>
      </el-form-item>
      <el-form-item label="区级区域奖" :rules="[{required: true,message: ' '}]" prop="region_rate">
        <el-input v-model="form.region_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为区级区域代理后，该地区的实付金额 的 {{form.region_rate}}% 收益奖励</div>
      </el-form-item>
      <el-form-item label="街道区域奖" :rules="[{required: true,message: ' '}]" prop="street_rate">
        <el-input v-model="form.street_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为街道区域代理后，该地区的实付金额 的 {{form.street_rate}}% 收益奖励</div>
      </el-form-item>
      <div class="common-form">自定义数据设置</div>

      <div style="display: flex;width: 90%;">
        <el-form-item label="设置" style="flex:0.5;" prop="data_setting">
          <el-select v-model="form.data_setting">
            <el-option label="未选择" :value="1"></el-option>
            <el-option label="企业总数" :value="2"></el-option>
            <el-option label="人口总数" :value="3"></el-option>
          </el-select>
 
   
      </el-form-item>
      </div>

      <div class="common-form">背景颜色设置</div>


      <div style="display: flex;width: 90%;">
        <el-form-item label="省代理字体颜色" style="flex:0.5;" prop="provinceColor">
        <div class="d-s-c">
        <el-color-picker v-model="form.provinceColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
          </div>
      </el-form-item>

      <el-form-item label="省代理背景" style="flex:0.5;" prop="provinceBg">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-color-picker v-model="form.provinceBg"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="省代理文字" style="flex:0.5;" prop="provinceText">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-input style="width:120px;"  v-model="form.provinceText"></el-input>
        </div>
      </el-form-item>


      <el-form-item label="预览" style="flex:0.5;">

        <div class="d-s-c">
       
          <el-button type="button" :style="{color:form.provinceColor,background:form.provinceBg}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            {{ form.provinceText  }}
          </el-button>
        </div>
      </el-form-item>
    </div>

    <div style="display: flex;width: 90%;">
        <el-form-item label="市代理字体颜色" style="flex:0.5;" prop="cityColor">
        <div class="d-s-c">
        <el-color-picker v-model="form.cityColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
          </div>
      </el-form-item>

      <el-form-item label="市代理背景" style="flex:0.5;" prop="cityBg">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-color-picker v-model="form.cityBg"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="市代理文字" style="flex:0.5;" prop="cityText">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-input style="width:120px;"  v-model="form.cityText"></el-input>
        </div>
      </el-form-item>


      <el-form-item label="预览" style="flex:0.5;">

        <div class="d-s-c">
       
          <el-button type="button" :style="{color:form.cityColor,background:form.cityBg}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            {{ form.cityText  }}
          </el-button>
        </div>
      </el-form-item>
    </div>


    <div style="display: flex;width: 90%;">
        <el-form-item label="县区代理字体颜色" style="flex:0.5;" prop="countyColor">
        <div class="d-s-c">
        <el-color-picker v-model="form.countyColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
          </div>
      </el-form-item>

      <el-form-item label="县区代理背景" style="flex:0.5;" prop="countyBg">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-color-picker v-model="form.countyBg"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="县区代理文字" style="flex:0.5;" prop="countyText">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-input style="width:120px;"  v-model="form.countyText"></el-input>
        </div>
      </el-form-item>


      <el-form-item label="预览" style="flex:0.5;">

        <div class="d-s-c">
       
          <el-button type="button" :style="{color:form.countyColor,background:form.countyBg}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            {{ form.countyText  }}
          </el-button>
        </div>
      </el-form-item>
    </div>



    <div style="display: flex;width: 90%;">
        <el-form-item label="街道乡镇代理字体颜色" style="flex:0.5;" prop="townColor">
        <div class="d-s-c">
        <el-color-picker v-model="form.townColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
          </div>
      </el-form-item>

      <el-form-item label="街道乡镇代理背景" style="flex:0.5;" prop="townBg">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-color-picker v-model="form.townBg"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="街道乡镇代理文字" style="flex:0.5;" prop="townText">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-input style="width:120px;"  v-model="form.townText"></el-input>
        </div>
      </el-form-item>


      <el-form-item label="预览" style="flex:0.5;">

        <div class="d-s-c">
       
          <el-button type="button" :style="{color:form.townColor,background:form.townBg}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            {{ form.townText  }}
          </el-button>
        </div>
      </el-form-item>
    </div>

    <div style="clear: both; height: 100px;width: 100rpx;"></div>


      <!-- region_agent -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import RegionagentApi from '@/api/regionagent.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,//省区域奖励
          type: 0,
          province_rate: 0,//省区域奖励
          city_rate: 0,//市区域奖励
          region_rate: 0,//区级区域奖励
          street_rate: 0,//街道区域奖励

          provinceBg:"",//省代理背景
          provinceColor:"",//省代理背景
          provinceText:"省代理",//省代理背景

          cityBg:"",//市代理背景
          cityColor:"",//市代理背景
          cityText:"市代理",//市代理背景

          countyBg:"",//县区代理背景
          countyColor:"",//县区代理背景
          countyText:"县区代理",//县区代理背景

          townBg:"",//街道乡镇代理背景
          townColor:"",//街道乡镇代理背景
          townText:"街道乡镇代理",//街道乡镇代理背景

          data_setting:1,//1 未选中  2  企业总数   3  人口总数
        },

      rules: {

        'provinceBg': [
          {required: true, message: '请选择省代理背景颜色', trigger: 'blur'},
        ],
        'provinceColor': [
          {required: true, message: '请选择省代理字体颜色', trigger: 'blur'},
        ],
        'provinceText': [
          {required: true, message: '请输入省文字', trigger: 'blur'},
        ],
        'cityBg': [
          {required: true, message: '请选择市代理背景颜色', trigger: 'blur'},
        ],
        'cityColor': [
          {required: true, message: '请选择市代理字体颜色', trigger: 'blur'},
        ],
        'cityText': [
          {required: true, message: '请输入市文字', trigger: 'blur'},
        ],
        'countyBg': [
          {required: true, message: '请选择县区代理背景颜色', trigger: 'blur'},
        ],
        'countyColor': [
          {required: true, message: '请选择县区代理字体颜色', trigger: 'blur'},
        ],
        'countyText': [
          {required: true, message: '请输入县区文字', trigger: 'blur'},
        ],
        'townBg': [
          {required: true, message: '请选择乡镇街道代理背景颜色', trigger: 'blur'},
        ],
        'townColor': [
          {required: true, message: '请选择乡镇街道代理字体颜色', trigger: 'blur'},
        ],
        'townText': [
          {required: true, message: '请输入乡镇街道文字', trigger: 'blur'},
        ],
      }

      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        RegionagentApi.getSetting({}, true)
          .then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);
            self.form.is_open = vars.is_open || self.form.is_open;
            self.form.type = vars.type || self.form.type;
            self.form.province_rate = vars.province_rate || self.form.province_rate;
            self.form.city_rate = vars.city_rate || self.form.city_rate;
            self.form.region_rate = vars.region_rate || self.form.region_rate;
            self.form.street_rate = vars.street_rate || self.form.street_rate;

            self.form.provinceBg = vars.provinceBg || self.form.provinceBg;
            self.form.provinceColor = vars.provinceColor || self.form.provinceColor;
            self.form.provinceText = vars.provinceText || self.form.provinceText;

            self.form.cityBg = vars.cityBg || self.form.cityBg;
            self.form.cityColor = vars.cityColor || self.form.cityColor;
            self.form.cityText = vars.cityText || self.form.cityText;

            self.form.countyBg = vars.countyBg || self.form.countyBg;
            self.form.countyColor = vars.countyColor || self.form.countyColor;
            self.form.countyText = vars.countyText || self.form.countyText;

            self.form.townBg = vars.townBg || self.form.townBg;
            self.form.townColor = vars.townColor || self.form.townColor;
            self.form.townText = vars.townText || self.form.townText;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            RegionagentApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/regionagent/setting/index.vue